var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 248,
    viewBox: "0 0 316 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_32698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1142 21.0881C47.3555 15.8479 43.7697 11.0488 38.75 8.66125C33.7304 6.27365 27.2442 6.67605 23.0771 10.3424C20.2066 12.8701 18.6775 16.611 18.0307 20.3638C17.0172 26.2419 18.0545 32.57 21.4764 37.4734C24.8984 42.3768 30.8301 45.6437 36.8304 45.292C50.4287 44.4961 52.6226 31.5506 49.1142 21.0881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.149 100.453C110.339 87.26 108.53 74.0671 106.721 60.8772C106.151 56.719 105.588 52.4178 106.569 48.3579C107.418 44.8466 109.403 41.6363 109.499 37.9998C109.603 34.0502 107.364 30.372 104.455 28.1185C101.546 25.865 98.0376 24.8098 94.5709 23.9871C86.4513 22.0586 78.129 21.1941 69.8275 21.4117C63.2877 21.5846 56.3932 22.5862 51.2155 27.0484C46.0767 31.4748 43.4655 38.5721 41.4386 45.4517C35.4711 65.6911 32.6423 86.8845 29.8345 107.962C29.3724 111.425 28.9313 115.095 30.1385 118.329C31.8435 122.895 36.2998 125.283 40.4758 126.946C58.128 133.981 77.2526 135.28 95.96 133.999C100.515 133.686 105.254 133.158 109.126 130.466C118.164 124.189 113.43 109.827 112.146 100.456L112.149 100.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.914 169.183C125.914 169.183 153.545 214.16 183.142 210.231C209.611 206.719 205.393 168.318 203.208 153.095C202.877 150.791 204.442 148.645 206.737 148.258C212.639 147.262 222.756 144.424 223.084 136.641C223.084 136.641 226.768 127.228 223.549 125.633C220.33 124.039 215.417 135.571 196.585 136.641C177.752 137.712 171.469 134.388 167.799 142.099L168.014 154.207L161.182 143.324C161.182 143.324 138.382 146.263 125.911 169.183H125.914Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.065 131.057C219.474 136.902 213.083 140.446 205.992 142.673",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.014 137.492C218.148 141.334 213.271 144.151 208.01 145.579",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.616 156.115C170.691 167.251 172.763 178.385 174.837 189.521",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.162 170.632C103.162 170.632 140.937 156.536 162.434 144.58C162.434 144.58 136.078 101.868 90.7049 99.8711L103.162 170.635V170.632Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8227 101.261C32.5947 100.429 92.5888 97.5405 108.309 103.797L124.337 136.627C131.539 151.382 134.311 167.908 132.317 184.207L132.946 247.703H11.3776L35.5845 210.476L31.8197 101.258L31.8227 101.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.43 118.381L124.337 136.626C131.539 151.381 132.486 161.605 132.317 184.205L132.946 247.702H11.3776L35.5845 210.475L33.7483 157.202",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1546 186.061C25.1546 186.061 52.6493 220.742 68.0808 227.601C83.5123 234.46 108.691 205.74 129.342 166.767C129.342 166.767 142.356 163.965 147.799 163.07C153.245 162.176 155.936 159.455 156.306 157.562C156.306 157.562 161.761 154.975 161.767 152.289C161.772 149.603 160.193 149.955 160.193 149.955C160.193 149.955 165.463 148.265 164.542 142.733C164.542 142.733 168.372 141.102 168.017 138.491C167.663 135.88 165.376 135.528 160.014 138.08C155.388 140.279 141.226 140.527 132.844 138.458C130.91 137.981 129.756 135.987 130.304 134.07C131.196 130.953 132.388 126.383 132.394 124.186C132.403 120.669 131.625 114.597 124.233 123.259C116.84 131.924 81.1396 170.481 74.6325 176.922L63.7825 164.221C63.7825 164.221 30.6333 172.773 25.1576 186.055L25.1546 186.061Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.652 146.025C150.288 146.991 157.203 145.933 163.245 143.029",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.463 152.291C149.548 152.5 154.672 151.665 159.427 149.85",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.485 159.235C147.494 159.119 151.489 158.433 155.307 157.205",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8217 103.439L39.7456 100.535C39.7456 100.535 11.5147 98.8483 4.11642 115.651C-3.28187 132.454 -2.10148 156.228 25.3187 186.266C25.3187 186.266 54.423 167.066 63.7766 164.226L40.8187 134.481V103.439H40.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3215 186.266C-2.09869 156.232 -3.28206 132.454 4.11921 115.651C11.5175 98.8487 39.7484 100.536 39.7484 100.536L56.089 100.098",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7794 164.226L40.8215 134.48",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3354 164.496C50.7714 169.954 39.1523 177.576 29.1429 186.926",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2867 67.4316L61.8717 99.8684C61.8717 99.8684 80.0068 106.018 87.0623 100.453L93.8674 80.4755L74.2837 67.4316H74.2867Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.089 100.097L61.8717 90.9102C61.8717 90.9102 70.9303 95.3426 80.3644 95.5035L83.0769 99.0417L84.8654 95.5035H90.0311L92.0729 102.786L88.4692 111.32L83.0769 104.938L78.2153 112.828C78.2153 112.828 61.6511 108.443 56.086 100.1L56.089 100.097Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.515 61.5371C103.135 65.4896 103.534 69.5673 102.64 73.4691C101.746 77.3709 99.3581 81.1118 95.7036 82.7423C92.6632 84.0985 89.1221 83.8571 85.9207 82.939C79.0441 80.9658 73.1302 75.8746 70.1524 69.3705C67.5055 69.8564 64.5516 68.8042 63.0642 66.5626C61.5768 64.3181 61.8719 60.9677 63.9316 59.2359C65.9913 57.5041 69.595 57.9542 70.9394 60.2881C72.707 59.4297 72.5937 56.9497 72.6801 54.9853C72.8948 50.0641 76.1021 45.6197 80.2275 42.9281C84.3529 40.2394 89.298 39.0888 94.1924 38.5344C96.4697 38.2751 98.6874 45.2114 99.3283 47.3814C100.699 52.0254 101.764 56.7589 102.515 61.543V61.5371Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0955 64.3604C67.5203 64.1845 69.0196 64.7837 69.9287 65.8985",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0892 100.098L93.8705 149.376L92.0761 102.783",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.655 102.783V128.469H63.7795V149.355L81.4912 167.064",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6813 102.783L110.435 127.217H99.8558L107.108 139.307",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.145 171.033H142.216V223.963H195.145V171.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.301 190.215H159.615C162.658 190.215 165.129 192.686 165.129 195.729V209.003H149.784V195.729C149.784 192.686 152.255 190.215 155.298 190.215H155.301Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.942 185.568C162.527 183.089 160.992 180.606 158.513 180.021C156.034 179.436 153.551 180.971 152.966 183.45C152.381 185.928 153.916 188.412 156.395 188.997C158.873 189.582 161.357 188.047 161.942 185.568Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.743 190.215H182.056C185.1 190.215 187.571 192.686 187.571 195.729V209.003H172.226V195.729C172.226 192.686 174.697 190.215 177.74 190.215H177.743Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.383 185.568C184.968 183.089 183.433 180.606 180.954 180.021C178.476 179.436 175.992 180.971 175.407 183.45C174.822 185.928 176.357 188.412 178.836 188.997C181.315 189.582 183.798 188.047 184.383 185.568Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16 194.547H171.201C174.757 194.547 177.645 197.435 177.645 200.991V215.087H159.716V200.991C159.716 197.435 162.604 194.547 166.16 194.547Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.679 193.282C171.655 193.282 174.068 190.87 174.068 187.893C174.068 184.917 171.655 182.504 168.679 182.504C165.703 182.504 163.29 184.917 163.29 187.893C163.29 190.87 165.703 193.282 168.679 193.282Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.216 231.305H195.142",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.216 239.506H195.142",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.216 247.703H195.142",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.925 171.033H201.995V223.963H254.925V171.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.251 182.605H229.045V203.775H250.251V182.605Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.047 181.615H219.802C226.178 181.615 232.479 183.01 238.256 185.702L232.968 187.651L243.156 205.289C244.867 208.251 241.457 211.655 238.921 209.485C238.864 209.435 238.804 209.384 238.748 209.33C239.374 212.386 235.204 213.173 233.093 210.505C233.666 213.304 229.862 214.702 227.314 211.706C228.241 214.919 223.707 216.186 221.635 212.887C219.447 209.402 212.714 197.917 212.714 197.917H206.666L207.047 181.618V181.615Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.196 199.381L213.277 202.362C212.395 202.743 211.37 202.335 210.988 201.456L210.526 200.389C210.144 199.506 210.553 198.481 211.435 198.102L218.354 195.122C219.236 194.74 220.261 195.148 220.643 196.028L221.105 197.095C221.486 197.977 221.078 199.003 220.196 199.381Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.524 203.33L215.605 206.311C214.723 206.693 213.697 206.284 213.316 205.405L212.854 204.338C212.472 203.456 212.881 202.43 213.763 202.052L220.681 199.071C221.564 198.689 222.589 199.098 222.971 199.977L223.433 201.044C223.814 201.926 223.406 202.952 222.524 203.33Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.188 207.28L218.27 210.26C217.388 210.642 216.362 210.234 215.981 209.354L215.519 208.287C215.137 207.405 215.546 206.379 216.428 206.001L223.346 203.02C224.229 202.638 225.254 203.047 225.636 203.926L226.098 204.993C226.479 205.876 226.071 206.901 225.188 207.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29 210.55L221.585 213.009C220.857 213.322 220.014 212.988 219.698 212.261L219.316 211.381C219 210.654 219.337 209.811 220.064 209.495L225.77 207.035C226.497 206.722 227.341 207.056 227.656 207.784L228.038 208.663C228.354 209.39 228.017 210.234 227.29 210.55Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.268 186.43L223.758 190.594C223.758 190.594 223.48 195.14 227.958 194.147C234.256 192.749 235.538 195.292 238.864 196.186C244.289 197.64 247.148 194.672 247.148 194.672",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.268 186.43L223.758 190.594C223.758 190.594 223.48 195.14 227.958 194.147C234.256 192.749 235.538 195.292 238.864 196.186C244.289 197.64 247.148 194.672 247.148 194.672",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.995 231.305H254.922",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.995 239.506H254.922",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.995 247.703H254.922",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.701 171.033H261.771V223.963H314.701V171.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.055 192.563H293.171V178.676H283.305V192.563H269.417V202.43H283.305V216.317H293.171V202.43H307.055V192.563Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.771 231.305H314.701",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.771 239.506H314.701",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.771 247.703H314.701",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.619 77.9023H288.238V161.605",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.021 0.298828H226.434C232.45 0.298828 237.329 5.17537 237.329 11.1936V83.2836C237.329 94.8013 230.876 105.347 220.622 110.587L187.395 127.572L156.222 110.74C146.308 105.386 140.129 95.0249 140.129 83.7575V11.1936C140.129 5.17836 145.006 0.298828 151.024 0.298828H151.021Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.356 102.244C223.513 98.5864 227.957 91.3193 227.957 83.2831V11.1931C227.957 10.3525 227.275 9.66992 226.434 9.66992H151.021C150.18 9.66992 149.497 10.3525 149.497 11.1931V83.7571C149.497 91.5905 153.781 98.7712 160.675 102.494L187.514 116.987L216.356 102.244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.064 32.6367H178.012C174.899 32.6367 172.375 35.1603 172.375 38.2734V64.066C172.375 67.179 174.899 69.7027 178.012 69.7027H309.064C312.177 69.7027 314.701 67.179 314.701 64.066V38.2734C314.701 35.1603 312.177 32.6367 309.064 32.6367Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.596155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.765 58.4409L184.575 62.2146L185.95 54.2202L180.131 48.5597L188.17 47.3942L191.765 40.1211L195.363 47.3942L203.402 48.5597L197.583 54.2202L198.958 62.2146L191.765 58.4409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.653 58.4409L210.46 62.2146L211.835 54.2202L206.016 48.5597L214.055 47.3942L217.653 40.1211L221.248 47.3942L229.287 48.5597L223.468 54.2202L224.843 62.2146L217.653 58.4409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.538 58.4409L236.349 62.2146L237.72 54.2202L231.904 48.5597L239.943 47.3942L243.538 40.1211L247.133 47.3942L255.172 48.5597L249.357 54.2202L250.728 62.2146L243.538 58.4409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.423 58.4409L262.234 62.2146L263.608 54.2202L257.789 48.5597L265.828 47.3942L269.423 40.1211L273.018 47.3942L281.057 48.5597L275.242 54.2202L276.616 62.2146L269.423 58.4409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.311 58.4409L288.119 62.2146L289.493 54.2202L283.674 48.5597L291.713 47.3942L295.311 40.1211L298.906 47.3942L306.945 48.5597L301.127 54.2202L302.501 62.2146L295.311 58.4409Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_32698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.068,
    height: 248,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.c9cd698a50d0b6e3300c982ddb7aabc5.svg";
export { ForwardRef as ReactComponent };